import type { ProviderRuntimeScope } from "../providers/runtime-filter.js";

export function schemaError(message: string): Error {
  return new Error(`[telemetry] ${message}`);
}

export function assertNonEmptyString(value: unknown, field: string): string {
  if (typeof value !== "string" || value.length === 0) {
    throw schemaError(`${field} must be a non-empty string`);
  }
  return value;
}

export function assertOptionalString(value: unknown, field: string): string | undefined {
  if (value === undefined) return undefined;
  if (typeof value !== "string") {
    throw schemaError(`${field} must be a string`);
  }
  return value;
}

export function assertSampleRate(value: unknown, field: string): number | undefined {
  if (value === undefined) return undefined;
  if (typeof value !== "number" || value < 0 || value > 1) {
    throw schemaError(`${field} must be a number between 0 and 1`);
  }
  return value;
}

export function assertBoolean(value: unknown, field: string): boolean | undefined {
  if (value === undefined) return undefined;
  if (typeof value !== "boolean") {
    throw schemaError(`${field} must be a boolean`);
  }
  return value;
}

export function assertHttpUrl(value: unknown, field: string): string {
  const str = assertNonEmptyString(value, field);
  try {
    const url = new URL(str);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      throw new Error("invalid protocol");
    }
  } catch {
    throw schemaError(`${field} must be a valid http(s) URL`);
  }
  return str;
}

export function parseProviderRuntime(
  value: unknown,
  fallback: ProviderRuntimeScope = "both",
): ProviderRuntimeScope {
  if (value === undefined) return fallback;
  if (value === "client" || value === "server" || value === "both") {
    return value;
  }
  throw schemaError('provider runtime must be "client", "server", or "both"');
}

export function parseRuntimeInput(
  value: unknown,
  fallback: "auto" | "client" | "server" = "auto",
): "auto" | "client" | "server" {
  if (value === undefined) return fallback;
  if (value === "auto" || value === "client" || value === "server") {
    return value;
  }
  throw schemaError('runtime must be "auto", "client", or "server"');
}
